// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.orders-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .orders-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .orders-page {
    padding: 16px 16px 28px;
  }
}

.orders-header {
  margin-bottom: 28px;
}
.orders-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.orders-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 640px) {
  .orders-header__title {
    font-size: 22px;
  }
}
.orders-header__count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(0, 173, 208), #008ba7);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.orders-header__count-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.orders-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
}
.orders-breadcrumb li {
  display: flex;
  align-items: center;
}
.orders-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
}
.orders-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.orders-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.orders-breadcrumb li.orders-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.orders-toolbar {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .orders-toolbar {
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
  }
}
.orders-toolbar__filter {
  flex: 1;
}
.orders-toolbar__filter label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.orders-toolbar__input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.orders-toolbar__input::placeholder {
  color: #ccc;
}
.orders-toolbar__input:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.orders-toolbar__input--date {
  padding-left: 34px;
}
.orders-toolbar__date {
  position: relative;
}
.orders-toolbar__date i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 13px;
  pointer-events: none;
  z-index: 1;
}

.orders-content {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: visible;
  min-height: 200px;
}

.orders-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.orders-state > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.orders-state p {
  font-size: 15px;
  color: #676a6c;
  margin: 0;
}

.orders-table-wrap {
  overflow-x: auto;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
}
.orders-table thead {
  background: #f1f1f2;
}
.orders-table thead th {
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  text-align: left;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.orders-table tbody tr {
  transition: background-color 0.12s ease;
  border-bottom: 1px solid #e7eaec;
}
.orders-table tbody tr:hover {
  background-color: rgba(0, 173, 208, 0.03);
}
.orders-table tbody tr:nth-of-type(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
.orders-table tbody tr:nth-of-type(even):hover {
  background-color: rgba(0, 173, 208, 0.03);
}
.orders-table tbody tr td {
  padding: 14px 16px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
}
.orders-table__link {
  color: rgb(0, 173, 208);
  text-decoration: none;
  font-weight: 600;
}
.orders-table__link:hover {
  text-decoration: underline;
}
.orders-table__customer {
  text-transform: capitalize;
}
.orders-table__amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.orders-table__actions-col {
  width: 100px;
  text-align: left;
}
.orders-table__actions {
  text-align: left;
}
.orders-table__view-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.15s ease;
}
.orders-table__view-btn:hover {
  border-color: rgb(0, 173, 208);
  color: rgb(0, 173, 208);
}

.orders-table__sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.15s ease;
}
.orders-table__sortable i.fa {
  margin-left: 4px;
  font-size: 12px;
  color: #ccc;
}
.orders-table__sortable:hover {
  color: rgb(0, 173, 208);
}
.orders-table__sortable:hover i.fa {
  color: rgb(0, 173, 208);
}

.orders-toolbar select.orders-toolbar__input {
  appearance: auto;
  cursor: pointer;
}
.orders-toolbar__filter--actions {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.orders-toolbar__reset {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 9px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: rgb(245, 67, 89);
  background: rgba(245, 67, 89, 0.06);
  border: 1px solid rgba(245, 67, 89, 0.15);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.orders-toolbar__reset:hover {
  background: rgb(245, 67, 89);
  color: #fff;
}

.orders-reset-btn {
  margin-top: 12px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: rgb(0, 173, 208);
  background: #fff;
  border: 1px solid rgb(0, 173, 208);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.orders-reset-btn:hover {
  background: rgba(0, 173, 208, 0.06);
}

.orders-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #e7eaec;
}
.orders-pagination__perpage {
  display: flex;
  align-items: center;
  gap: 8px;
}
.orders-pagination__perpage label {
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  margin: 0;
  white-space: nowrap;
}
.orders-pagination__perpage select {
  width: 70px;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  color: #676a6c;
  background: #fff;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.orders-pagination__perpage select:focus {
  border-color: rgb(0, 173, 208);
  outline: none;
}
.orders-pagination__pages {
  display: flex;
  align-items: center;
  gap: 4px;
}
.orders-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.orders-pagination__btn:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.orders-pagination__btn--active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
.orders-pagination__btn--active:hover {
  background: #606164;
}

.orders-status-badge {
  display: inline-block;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  border-radius: 3px;
  letter-spacing: 0.03em;
}
.orders-status-badge--paid {
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.1);
}
.orders-status-badge--processing {
  color: rgb(0, 173, 208);
  background: rgba(0, 173, 208, 0.1);
}
.orders-status-badge--cancelled {
  color: rgb(245, 67, 89);
  background: rgba(245, 67, 89, 0.1);
}
.orders-status-badge--expired {
  color: rgb(255, 121, 0);
  background: rgba(255, 121, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/store-orders/store-orders.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAzYA;EACE,uBAAA;EACA,iBAAA;AA4YF;AA1YE;EAJF;IAI8B,uBAAA;EA8Y5B;AACF;AA9YE;EALF;IAK8B,uBAAA;EAkZ5B;AACF;;AA5YA;EACE,mBAAA;AA+YF;AA7YE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA+YJ;AA5YE;EACE,eAAA;EACA,gBAAA;EACA,cDWiB;ECVjB,SAAA;EACA,uBAAA;EACA,wEDhCS;AC8ab;AA5YI;EARF;IAQ8B,eAAA;EAgZ9B;AACF;AA9YE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,8DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDhDS;ACgcb;AA9YI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AAgZN;;AAvYA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AA0YF;AAxYE;EACE,aAAA;EACA,mBAAA;AA0YJ;AAxYI;EACE,YAAA;EACA,aAAA;EACA,WDrCc;AC+apB;AAvYI;EACE,cDhDe;ECiDf,qBAAA;EACA,4BAAA;AAyYN;AAvYM;EAAU,uBDlEA;AC4chB;AAvYI;EACE,cDnDe;ECoDf,gBAAA;AAyYN;;AAhYA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBD/DoB;ECgEpB,kBAAA;EACA,yBAAA;AAmYF;AAjYE;EATF;IAUI,sBAAA;IACA,SAAA;IACA,kBAAA;EAoYF;AACF;AAlYE;EACE,OAAA;AAoYJ;AAlYI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDrFe;ECsFf,kBAAA;AAoYN;AAhYE;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEDxIS;ECyIT,cDtGiB;ECuGjB,gBAAA;EACA,aAAA;EACA,wDAAA;AAkYJ;AAhYI;EAAiB,WDpGD;ACuepB;AAjYI;EACE,8BD5HU;EC6HV,4CAAA;AAmYN;AAhYI;EACE,kBAAA;AAkYN;AA9XE;EACE,kBAAA;AAgYJ;AA9XI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WDxHc;ECyHd,eAAA;EACA,oBAAA;EACA,UAAA;AAgYN;;AAvXA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AA0XF;;AAnXA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAsXF;AApXE;EACE,eAAA;EACA,mBAAA;EACA,WD3JgB;ACihBpB;AAnXE;EACE,eAAA;EACA,cDvKiB;ECwKjB,SAAA;AAqXJ;;AA7WA;EACE,gBAAA;AAgXF;;AA7WA;EACE,WAAA;EACA,yBAAA;AAgXF;AA9WE;EACE,mBDjLkB;ACiiBtB;AA9WI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD5Le;EC6Lf,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,wEDxOO;ACwlBb;AA5WE;EACE,uCAAA;EACA,gCAAA;AA8WJ;AA5WI;EAAU,yCAAA;AA+Wd;AA7WI;EACE,0CAAA;AA+WN;AA7WM;EAAU,yCAAA;AAgXhB;AA7WI;EACE,kBAAA;EACA,eAAA;EACA,cDxNe;ECyNf,sBAAA;AA+WN;AA3WE;EACE,uBD5OY;EC6OZ,qBAAA;EACA,gBAAA;AA6WJ;AA3WI;EAAU,0BAAA;AA8Wd;AA3WE;EACE,0BAAA;AA6WJ;AA1WE;EACE,gBAAA;EACA,kCAAA;AA4WJ;AAzWE;EACE,YAAA;EACA,gBAAA;AA2WJ;AAxWE;EACE,gBAAA;AA0WJ;AAvWE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cD9PiB;EC+PjB,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;AAyWJ;AAvWI;EACE,8BDpRU;ECqRV,uBDrRU;AC8nBhB;;AA5VA;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AA+VF;AA7VE;EACE,gBAAA;EACA,eAAA;EACA,WDrRgB;AConBpB;AA5VE;EACE,uBD9SY;AC4oBhB;AA5VI;EAAO,uBDhTK;AC+oBhB;;AAtVE;EACE,gBAAA;EACA,eAAA;AAyVJ;AAtVE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAwVJ;AArVE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDjWS;ECkWT,uBD1Uc;EC2Ud,mCAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAuVJ;AArVI;EACE,4BDlVY;ECmVZ,WAAA;AAuVN;;AAlVA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDrXW;ECsXX,uBDjWc;ECkWd,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;AAqVF;AAnVE;EACE,mCAAA;AAqVJ;;AA7UA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;AAgVF;AA9UE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAgVJ;AA9UI;EACE,eAAA;EACA,gBAAA;EACA,cD7We;EC8Wf,SAAA;EACA,mBAAA;AAgVN;AA7UI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,cD7Xe;EC8Xf,gBAAA;EACA,wEDlaO;ACivBb;AA7UM;EACE,8BDhZQ;ECiZR,aAAA;AA+UR;AA1UE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA4UJ;AAzUE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDzZiB;EC0ZjB,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,wEDhcS;AC2wBb;AAzUI;EACE,mBDxZgB;ECyZhB,kBD1Zc;ACquBpB;AAxUI;EACE,mBDhae;ECiaf,WAAA;EACA,qBDlae;AC4uBrB;AAxUM;EACE,mBAAA;AA0UR;;AAhUA;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;AAmUF;AAjUE;EACE,wBD1cY;EC2cZ,mCAAA;AAmUJ;AAhUE;EACE,uBDjdY;ECkdZ,kCAAA;AAkUJ;AA/TE;EACE,uBDndc;ECodd,kCAAA;AAiUJ;AA9TE;EACE,uBD1dW;EC2dX,kCAAA;AAgUJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n// ─────────────────────────────────────────────\n// Page Layout\n// ─────────────────────────────────────────────\n\n.orders-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// ─────────────────────────────────────────────\n// Header\n// ─────────────────────────────────────────────\n\n.orders-header {\n  margin-bottom: 28px;\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n\n  &__count {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    height: 28px;\n    padding: 0 12px;\n    border-radius: 14px;\n    background: linear-gradient(135deg, $clarify-color, darken($clarify-color, 8%));\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: $font-stack;\n\n    &-label {\n      font-size: 11px;\n      font-weight: 500;\n      opacity: 0.85;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Breadcrumb\n// ─────────────────────────────────────────────\n\n.orders-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after {\n      content: '/';\n      margin: 0 8px;\n      color: $color-neutral-mid;\n    }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n\n      &:hover { color: $clarify-color; }\n    }\n\n    &.orders-breadcrumb__current {\n      color: $color-neutral-dark;\n      font-weight: 600;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Toolbar / Filters\n// ─────────────────────────────────────────────\n\n.orders-toolbar {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  padding: 16px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n\n  &__filter {\n    flex: 1;\n\n    label {\n      display: block;\n      font-size: 11px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      color: $color-neutral-dark;\n      margin-bottom: 6px;\n    }\n  }\n\n  &__input {\n    width: 100%;\n    padding: 9px 12px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n    background: #fff;\n    outline: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n    &::placeholder { color: $color-neutral-mid; }\n\n    &:focus {\n      border-color: $clarify-color;\n      box-shadow: 0 0 0 3px rgba($clarify-color, 0.1);\n    }\n\n    &--date {\n      padding-left: 34px;\n    }\n  }\n\n  &__date {\n    position: relative;\n\n    i {\n      position: absolute;\n      left: 12px;\n      top: 50%;\n      transform: translateY(-50%);\n      color: $color-neutral-mid;\n      font-size: 13px;\n      pointer-events: none;\n      z-index: 1;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Content Area\n// ─────────────────────────────────────────────\n\n.orders-content {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n  overflow: visible;\n  min-height: 200px;\n}\n\n// ─────────────────────────────────────────────\n// States\n// ─────────────────────────────────────────────\n\n.orders-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i {\n    font-size: 36px;\n    margin-bottom: 16px;\n    color: $color-neutral-mid;\n  }\n\n  p {\n    font-size: 15px;\n    color: $body-content-color;\n    margin: 0;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Table\n// ─────────────────────────────────────────────\n\n.orders-table-wrap {\n  overflow-x: auto;\n}\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  thead {\n    background: $color-neutral-light;\n\n    th {\n      padding: 12px 16px;\n      font-size: 11px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      color: $color-neutral-dark;\n      border-bottom: 2px solid $color-grey-1;\n      text-align: left;\n      white-space: nowrap;\n      font-family: $font-stack;\n    }\n  }\n\n  tbody tr {\n    transition: background-color 0.12s ease;\n    border-bottom: 1px solid $color-grey-1;\n\n    &:hover { background-color: rgba($clarify-color, 0.03); }\n\n    &:nth-of-type(even) {\n      background-color: rgba($color-neutral-light, 0.5);\n\n      &:hover { background-color: rgba($clarify-color, 0.03); }\n    }\n\n    td {\n      padding: 14px 16px;\n      font-size: 13px;\n      color: $body-content-color;\n      vertical-align: middle;\n    }\n  }\n\n  &__link {\n    color: $clarify-color;\n    text-decoration: none;\n    font-weight: 600;\n\n    &:hover { text-decoration: underline; }\n  }\n\n  &__customer {\n    text-transform: capitalize;\n  }\n\n  &__amount {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__actions-col {\n    width: 100px;\n    text-align: left;\n  }\n\n  &__actions {\n    text-align: left;\n  }\n\n  &__view-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 5px 12px;\n    font-size: 12px;\n    font-weight: 600;\n    color: $body-content-color;\n    background: #fff;\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n    text-decoration: none;\n    transition: all 0.15s ease;\n\n    &:hover {\n      border-color: $clarify-color;\n      color: $clarify-color;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Status Badge\n// ─────────────────────────────────────────────\n\n// ─────────────────────────────────────────────\n// Sortable Headers\n// ─────────────────────────────────────────────\n\n.orders-table__sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: color 0.15s ease;\n\n  i.fa {\n    margin-left: 4px;\n    font-size: 12px;\n    color: $color-neutral-mid;\n  }\n\n  &:hover {\n    color: $clarify-color;\n\n    i.fa { color: $clarify-color; }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Toolbar extras\n// ─────────────────────────────────────────────\n\n.orders-toolbar {\n  select.orders-toolbar__input {\n    appearance: auto;\n    cursor: pointer;\n  }\n\n  &__filter--actions {\n    flex: 0 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n\n  &__reset {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 9px 14px;\n    font-size: 12px;\n    font-weight: 600;\n    font-family: $font-stack;\n    color: $implement-color;\n    background: rgba($implement-color, 0.06);\n    border: 1px solid rgba($implement-color, 0.15);\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background: $implement-color;\n      color: #fff;\n    }\n  }\n}\n\n.orders-reset-btn {\n  margin-top: 12px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  color: $clarify-color;\n  background: #fff;\n  border: 1px solid $clarify-color;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background: rgba($clarify-color, 0.06);\n  }\n}\n\n// ─────────────────────────────────────────────\n// Pagination\n// ─────────────────────────────────────────────\n\n.orders-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-top: 1px solid $color-grey-1;\n\n  &__perpage {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    label {\n      font-size: 12px;\n      font-weight: 600;\n      color: $color-neutral-dark;\n      margin: 0;\n      white-space: nowrap;\n    }\n\n    select {\n      width: 70px;\n      padding: 4px 8px;\n      font-size: 13px;\n      border: 1px solid $color-grey-1;\n      border-radius: 4px;\n      color: $body-content-color;\n      background: #fff;\n      font-family: $font-stack;\n\n      &:focus {\n        border-color: $clarify-color;\n        outline: none;\n      }\n    }\n  }\n\n  &__pages {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 32px;\n    height: 32px;\n    padding: 0 8px;\n    border: 1px solid $color-grey-1;\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 500;\n    color: $body-content-color;\n    background: #fff;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    font-family: $font-stack;\n\n    &:hover {\n      background: $color-neutral-light;\n      border-color: $color-neutral-mid;\n    }\n\n    &--active {\n      background: $color-neutral-dark;\n      color: #fff;\n      border-color: $color-neutral-dark;\n\n      &:hover {\n        background: darken($color-neutral-dark, 5%);\n      }\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Status Badge\n// ─────────────────────────────────────────────\n\n.orders-status-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: capitalize;\n  border-radius: 3px;\n  letter-spacing: 0.03em;\n\n  &--paid {\n    color: $develop-color;\n    background: rgba($develop-color, 0.1);\n  }\n\n  &--processing {\n    color: $clarify-color;\n    background: rgba($clarify-color, 0.1);\n  }\n\n  &--cancelled {\n    color: $implement-color;\n    background: rgba($implement-color, 0.1);\n  }\n\n  &--expired {\n    color: $ideate-color;\n    background: rgba($ideate-color, 0.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
